/**
 * ERP & Treuhandbüro Data Portability / Connector Module (`web/src/components/StepUpDialog.tsx`).
 *
 * @statutory OR Art. 957a Abs. 2 Ziff. 1–5 (Vollständige & nachprüfbare Buchführung) · GeBüV Art. 6–10 (Datenübernahme & Prüfspur) · MWSTG Art. 70 · Schweizer Kontenrahmen KMU
 */
import { useEffect, useState } from 'react';
import { api, ApiError } from '../lib/api';
import { Modal } from './ui';

/** Shown when a sensitive action answers 403 auth=step_up. The write is not retried. */
export function StepUpDialog() {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const onNeed = () => { setOpen(true); setDone(false); setError(null); setCode(''); };
    window.addEventListener('kontor-step-up', onNeed);
    return () => window.removeEventListener('kontor-step-up', onNeed);
  }, []);

  if (!open) return null;

  const close = () => setOpen(false);
  const submit = async () => {
    setBusy(true);
    setError(null);
    try {
      await api.post('/api/auth/step-up', { code });
      setDone(true);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Der Code konnte nicht geprüft werden.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal title="Schritt bestätigen" onClose={close}>
      <form className="card-pad step-up-panel" lang="de" onSubmit={(e) => { e.preventDefault(); if (!done) void submit(); }}>
        <p>
          Step-Up 2FA erforderlich: bitte bestätigen Sie diese Aktion mit Ihrem aktuellen 6-stelligen TOTP-Code.
          Die Aktion wird nicht automatisch wiederholt.
        </p>
        {done ? (
          <p>Der Code ist 15 Minuten gültig. Wiederholen Sie die Aktion.</p>
        ) : (
          <label className="field">
            <span>Einmalcode</span>
            <input
              className="input"
              inputMode="numeric"
              autoComplete="one-time-code"
              maxLength={6}
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              aria-invalid={error ? true : undefined}
            />
          </label>
        )}
        {error && <p role="alert">{error}</p>}
        <div className="step-up-actions">
          {done ? (
            <button type="button" className="btn primary" onClick={close}>Schliessen</button>
          ) : (
            <button type="submit" className="btn primary" disabled={busy || code.length !== 6}>{busy ? 'Prüfen…' : 'Bestätigen'}</button>
          )}
          {!done && <button type="button" className="btn" onClick={close}>Abbrechen</button>}
        </div>
      </form>
    </Modal>
  );
}
